/* @ngInject */
export default class RegisterController {
  public countryCode: String;

  constructor(private $document) {}

  public onReturnLogin() {
    const login = this.$document.find('.login');
    login.siblings('.active').removeClass('active');
    login.addClass('active');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login-dialog/register/register.controller.ts